export function SET_CLIENTS(state, clients) {
  state.clients = clients;
}

export function SET_ESPECIALIDADES(state, especialidades) {
  state.especialidades = especialidades;
}

// CERTIFICADOS
export function SET_CERTIFICATES(state, certificates) {
  state.certificates = certificates;
}

export function ADD_CERTIFICATER(state, certificater) {
  state.certificates.list.unshift(certificater);
  state.certificates = { ...state.certificates }
}

export function ADD_CERTIFICATE(state, certificate) {
  state.certificates.list.find((certificater, i) => {
    if (certificate.id_certificadora == certificater.id)
      state.certificates.list[i].certificados.unshift(certificate)
  })
  /* state.certificates = { ...state.certificates } */
}

export function DEL_CERTIFICATER(state, certificater) {
  state.certificates.list = state.certificates.list.filter(
    (cert) => cert.id != certificater.id
  );

  state.certificates = { ...state.certificates }
}
export function DEL_CERTIFICATE(state, certificate) {
  state.certificates.list.find((certificater, i) => {
    if (certificate.id_certificadora == certificater.id)
      state.certificates.list[i].certificados = state.certificates.list[i].certificados.filter(
        (cert) => cert.id != certificate.id
      );
  })

}

export function UPDATE_CERTIFICATER(state, newCertificater) {
  newCertificater.show = false
  state.certificates.list.find((certificater, i) => {
    if (newCertificater.id == certificater.id) {
      state.certificates.list[i] = { ...state.certificates.list[i], ...newCertificater }
      state.certificates = { ...state.certificates }
    }
  })

}

export function UPDATE_CERTIFICATE(state, certificate) {

  state.certificates.list.find((certificater, i) => {
    if (certificate.id_certificadora == certificater.id)
      state.certificates.list[i].certificados.find(
        (cert, j) => {
          if (cert.id == certificate.id) {
            certificate.show = false
            state.certificates.list[i].certificados[j] = certificate
            state.certificates = { ...state.certificates }
          }
        }
      );
  })

}


// FERRAMENTAS
export function SET_TOOLS(state, tools) {
  state.tools = tools;
}
export function ADD_TOOLTYPE(state, tooltype) {
  state.tools.list.unshift(tooltype);
  state.tools = { ...state.tools }
}

export function ADD_TOOL(state, tool) {
  state.tools.list.find((tooltype, i) => {
    if (tool.id_tipo_ferramenta == tooltype.id)
      state.tools.list[i].ferramentas.unshift(tool)
  })
  state.tools = { ...state.tools }
}

export function DEL_TOOLTYPE(state, tooltype) {
  state.tools.list = state.tools.list.filter(
    (t) => t.id != tooltype.id
  );

  state.tools = { ...state.tools }
}
export function DEL_TOOL(state, tool) {
  state.tools.list.find((tooltype, i) => {
    if (tool.id_tipo_ferramenta == tooltype.id)
      state.tools.list[i].ferramentas = state.tools.list[i].ferramentas.filter(
        (t) => t.id != tool.id
      );
  })

  state.tools = { ...state.tools }
}

export function UPDATE_TOOL(state, tool) {

  state.tools.list.find((tooltype, i) => {
    if (tool.id_tipo_ferramenta == tooltype.id)
      state.tools.list[i].ferramentas.find(
        (t, j) => {
          if (t.id == tool.id) {
            tool.show = false
            state.tools.list[i].ferramentas[j] = tool
            state.tools = { ...state.tools }
          }
        }
      );
  })

}